module.exports = __webpack_public_path__ + "static/img/warning.d6024ebe.png";